import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef } from 'react';
import { viewBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { isNavLinkItem, onClickLogoRio } from '../../shared';
import { MobileHeaderContainer, Divider } from '../../styles/root';
import CheggLogo from '../shared/cheggLogo';
import SecondaryNav from '../shared/secondaryNav';
import CenterNav from './mobileCenterNav';
import HamburgerMenu from './mobileHamburgerMenu';

var MobileHeader = function MobileHeader(_ref) {
  var logo = _ref.logo,
      _onClickLogo = _ref.onClickLogo,
      onCloseHamburger = _ref.onCloseHamburger,
      _onOpenHamburger = _ref.onOpenHamburger,
      secondaryNavLinks = _ref.secondaryNavLinks,
      activeLink = _ref.activeLink,
      navLinks = _ref.navLinks;
  var hamburgerMenuRef = useRef(null);
  return /*#__PURE__*/React.createElement(MobileHeaderContainer, {
    role: "banner"
  }, /*#__PURE__*/React.createElement(HamburgerMenu, {
    logo: logo,
    onClickLogo: _onClickLogo,
    onCloseHamburger: onCloseHamburger,
    onOpenHamburger:
    /* istanbul ignore next */
    function onOpenHamburger(e) {
      // Side Nav Event
      navLinks.length && rioClient.sendEvent(_objectSpread(_objectSpread({}, viewBaseEvent), {}, {
        data: {
          component_view: {
            component: {
              name: 'nav bar',
              type: 'component',
              region_name: 'side nav',
              text: navLinks.map(function (navItem) {
                return isNavLinkItem(navItem) ? navItem.text : navItem.parent.text;
              }).join('|').toLowerCase()
            },
            state: 'expanded'
          }
        }
      }));
      _onOpenHamburger === null || _onOpenHamburger === void 0 ? void 0 : _onOpenHamburger(e);
    },
    ref: hamburgerMenuRef
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenterNav, {
    navLinks: navLinks,
    activeLink: activeLink,
    hamburgerMenuRef: hamburgerMenuRef
  }), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(SecondaryNav, {
    secondaryNavLinks: secondaryNavLinks,
    isMobile: true,
    activeLink: activeLink
  }))), /*#__PURE__*/React.createElement(CheggLogo, {
    logo: logo,
    onClickLogo:
    /* istanbul ignore next */
    function onClickLogo(e) {
      onClickLogoRio();
      _onClickLogo === null || _onClickLogo === void 0 ? void 0 : _onClickLogo(e);
    }
  }));
};

MobileHeader.displayName = 'MobileHeader';
export default MobileHeader;